import {
  ActiveCallCenterIcon,
  ActiveCallIcon,
  AvailableIcon,
  AvgWaitTimeIcon,
  CallCenterListIcon1,
  CallerIcon,
  DepartmentIcon,
  ExtensionIcon,
  IncomingCallsIcon,
  LoggedOutIcon,
  MaxWaitTimeIcon,
  MinWaitTimeIcon,
  OnCallIcon,
  OutgoingCallsIcon,
  ParkedCallsIcon,
  QueueCallIcon,
  TireIcon,
  TotalCallCenterCallIcon,
  TotalCallsIcon,
  TotalUsersIcon,
  UserIcon,
  WaitingIcon,
} from "assets";
import { useMemo } from "react";
import colors from "../../../../styles/colors.module.scss";
import MiniCard from "components/features/LiveCalls/MiniCard";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useQueueWaitTimes } from "hooks/useQueueWaitTimes";

const CallCenterStats = () => {
  const { activeCalls, queueCalls } = useSelector((state: RootState) => state.callCenter);

  const waitTimeStats = useQueueWaitTimes();

  const callCenterStats = useMemo(
    () => [
      {
        value:
          String(
            (Array.isArray(queueCalls) ? queueCalls.length : Object.keys(queueCalls).length) +
            (Array.isArray(activeCalls) ? activeCalls.length : Object.keys(activeCalls).length)
          ),
        heading: "Total Calls",
        iconClassName: TotalCallCenterCallIcon,
        containerBg: colors.lightOrange,
        imageContainerBg: colors.darkOrange,
      },
      {
        value: String(Array.isArray(queueCalls) ? queueCalls.length : Object.keys(queueCalls).length),
        heading: "Queued Calls",
        iconClassName: QueueCallIcon,
        containerBg: colors.lightGreen,
        imageContainerBg: colors.darkGreen,
      },
      {
        value: String(Array.isArray(activeCalls) ? activeCalls.length : Object.keys(activeCalls).length),
        heading: "Active Calls",
        iconClassName: ActiveCallCenterIcon,
        containerBg: colors.lightCyan,
        imageContainerBg: colors.darkCyan,
      },
      {
        value: waitTimeStats.avg,
        heading: "Average Waiting Time",
        iconClassName: AvgWaitTimeIcon,
        containerBg: colors.lightGreen,
        imageContainerBg: colors.darkGreen,
      },
      {
        value: waitTimeStats.max,
        heading: "Max Waiting Time",
        iconClassName: MaxWaitTimeIcon,
        containerBg: colors.lightPurple,
        imageContainerBg: colors.darkPurple,
      },
      {
        value: waitTimeStats.min,
        heading: "Least Waiting Time",
        iconClassName: MinWaitTimeIcon,
        containerBg: colors.lightMaroon,
        imageContainerBg: colors.darkMaroon,
      },


    ],
    [waitTimeStats.avg, waitTimeStats.min, waitTimeStats.max, queueCalls, activeCalls]
  );

  return (
    <>
      {callCenterStats.map((card, idx) => (
        <MiniCard key={idx} {...card} />
      ))}
    </>
  );
};

export default CallCenterStats;
